/*
 DocumentNavbar component
 url match: / or /home
 Displays overview 
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles } from '@material-ui/core/styles';
import { documentStyles } from '../../Styles/documentStyles';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Toolbar from '@material-ui/core/Toolbar';

/*const StyledDrawer = styled(Drawer)`
  & > div {
    width: 16%;
  }
`; */

@inject('userStore', 'documentStore')
@observer
class DocumentNavbar extends React.Component {

    state = {
        open: false,
    }

    componentWillUnmount() {
        // this.props.userStore.reset();
    }

    handleDrawerToggle = () => {
        this.setState({
            open: !this.state.open
        })
    }

    handleThumbnailClick(currentPage, index) {
        const { currentDoc, financeDocs } = this.props.documentStore;

        this.props.resetImage()
        if (financeDocs.findIndex(x => x === currentDoc.docType) > -1)
            this.props.documentStore.setCurrentImagePoSo(currentPage, index + 1);
        else
            this.props.documentStore.setCurrentImage(currentPage, index + 1);

    }

    render() {
        const { classes, type } = this.props;
        const { currentPage, currentDoc } = this.props.documentStore;
        const drawer = (
            <div className={classes.sidebarFlex}>
                <div style={{ paddingTop: '1vh' }} className={classes.imageName}>
                    {currentPage.pageNo}/{currentDoc.pageArray.length} Pages
                    <div >
                        {<List>
                            {currentDoc.pageArray.map((item, index) => (
                                <ListItem style={{ justifyContent: 'center' }} button key={item.pageNo}>
                                    <div className={classes.columnFlex}>
                                        <div className={classes.thumbnailContainer} style={{ border: item.pageNo == currentPage.pageNo ? '4px solid #9097a2' : 'none' }}>
                                            <img alt="previewDoc" className={classes.thumbnails} src={currentDoc.pageArray[`${index}`].pageImageLink} onClick={() => this.handleThumbnailClick(item, index)}>
                                            </img>
                                            {
                                                type !== 'poso' ?
                                                    <ReactSVG className={classes.thumbnailIcons} src={currentDoc.pageArray[index].reviewed ? Images.check : Images.error} />
                                                    : null
                                            }
                                        </div>
                                        <div className={classes.imageName}>
                                            {index + 1}
                                        </div>
                                    </div>
                                </ListItem>
                            ))}
                        </List>}
                    </div>
                </div>
                <div className={classes.sidebarFooter} >
                    <div>
                        © Amygb 2020
                    </div>
                </div>
            </div>

        );
        const { open } = this.state
        return (
            <div className={classes.navbarContainer}>
                <CssBaseline />
                <Hidden smUp implementation="css">
                    <AppBar position="fixed" className={classes.appBar}>
                        <Toolbar>
                            <IconButton
                                aria-label="open drawer"
                                edge="start"
                                onClick={this.handleDrawerToggle}
                                className={classes.menuButton}
                            >
                                <MenuIcon className={classes.menuIcon} />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                </Hidden>
                <nav className={classes.drawer} aria-label="navigation bar">
                    {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                    <Hidden smUp implementation="css">
                        <Drawer
                            anchor="right"
                            variant="temporary"
                            open={open}
                            onClose={this.handleDrawerToggle}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                            ModalProps={{
                                keepMounted: true, // Better open performance on mobile.
                            }}
                        >
                            <IconButton onClick={this.handleDrawerToggle} className={classes.closeMenuButton}>
                                <ReactSVG src={Images.logo} />
                            </IconButton>
                            {drawer}
                        </Drawer>
                    </Hidden>
                    <Hidden xsDown implementation="css">
                        <Drawer
                            className={classes.drawer}
                            variant="permanent"
                            anchor="right"
                            docked={classes.drawerPaper}
                            classes={{
                                paper: classes.drawerPaper,
                            }}
                        >
                            {drawer}
                        </Drawer>
                    </Hidden>
                </nav>
            </div>
        );
    }
}

export default withStyles(documentStyles, { withTheme: true })(withRouter(DocumentNavbar));
